export enum ProductType {
  Concrete = 0,
  Article = 1,
  Resource = 2
}

export enum PriceCalculationType {
  FixedPrice = 1,
  PercentageAdjustment = 2,
  AmountAdjustment = 3
}

export enum AdjustmentDirection {
  Discount = -1,
  Surcharge = 1
}

export interface PriceAgreementRule {
  id: number;
  price_agreements_id: number;
  product_type: ProductType;
  product_id: number;
  price_calculation_type: PriceCalculationType;
  adjustment_direction: AdjustmentDirection | null;
  value: number;
}
